import { ApplicationRef, Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { concat, filter, first, interval } from 'rxjs';
import { LoggerService } from './logger.service';

const UPDATE_CHECK_INTERVAL_MS = 10 * 60 * 1000;

/**
 * Picks up newly deployed versions. The reload is left to the user on purpose:
 * an unprompted one costs them whatever they had typed into registration or
 * onboarding, and this runs on the public storefronts too.
 */
@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private updates = inject(SwUpdate);
  private appRef = inject(ApplicationRef);
  private logger = inject(LoggerService);

  start(): void {
    if (!this.updates.isEnabled) {
      return;
    }

    this.updates.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        this.logger.log('✨ [SERVICE WORKER] New version ready');
        // Already-loaded tabs keep being served the version they started with,
        // so staying on the old one until the next reload is safe
        if (confirm('Eine neue Version von Schenkwerk ist verfügbar. Jetzt neu laden?')) {
          document.location.reload();
        }
      });

    // Polling before the app is stable never settles, so wait for stability first
    const appIsStable = this.appRef.isStable.pipe(first((stable) => stable));
    concat(appIsStable, interval(UPDATE_CHECK_INTERVAL_MS)).subscribe(() => {
      this.updates.checkForUpdate().catch((err) => {
        this.logger.log('❌ [SERVICE WORKER] Update check failed:', err);
      });
    });
  }
}
